"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNotCreatedRippleMockAddress = void 0;
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const bignumber_js_1 = require("bignumber.js");
const errors_1 = require("@ledgerhq/errors");
const account_1 = require("../../../account");
const mockHelpers_1 = require("../../../bridge/mockHelpers");
const jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const currencies_1 = require("../../../currencies");
const mockHelpers_2 = require("../../../bridge/mockHelpers");
const receive = (0, mockHelpers_2.makeAccountBridgeReceive)();
const notCreatedAddresses = [];
function addNotCreatedRippleMockAddress(addr) {
    notCreatedAddresses.push(addr);
}
exports.addNotCreatedRippleMockAddress = addNotCreatedRippleMockAddress;
const defaultGetFees = (a, t) => t.fee || new bignumber_js_1.BigNumber(0);
const createTransaction = () => ({
    family: "ripple",
    amount: new bignumber_js_1.BigNumber(0),
    recipient: "",
    fee: new bignumber_js_1.BigNumber(10),
    feeCustomUnit: (0, cryptoassets_1.getCryptoCurrencyById)("ripple").units[1],
    tag: undefined,
    networkInfo: null,
    useAllAmount: false,
});
const estimateMaxSpendable = ({ account, parentAccount, transaction }) => {
    const mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    const estimatedFees = transaction ? defaultGetFees(mainAccount, transaction) : new bignumber_js_1.BigNumber(10);
    return Promise.resolve(bignumber_js_1.BigNumber.max(0, account.balance.minus(estimatedFees)));
};
const getTransactionStatus = (a, t) => {
    const minimalBaseAmount = Math.pow(10, a.currency.units[0].magnitude) * 20;
    const errors = {};
    const warnings = {};
    const useAllAmount = !!t.useAllAmount;
    const estimatedFees = defaultGetFees(a, t);
    const totalSpent = useAllAmount ? a.balance : new bignumber_js_1.BigNumber(t.amount).plus(estimatedFees);
    const amount = useAllAmount ? a.balance.minus(estimatedFees) : new bignumber_js_1.BigNumber(t.amount);
    if (amount.gt(0) && estimatedFees.times(10).gt(amount)) {
        warnings.feeTooHigh = new errors_1.FeeTooHigh();
    }
    if (totalSpent.gt(a.balance)) {
        errors.amount = new errors_1.NotEnoughSpendableBalance("", {
            minimumAmount: (0, currencies_1.formatCurrencyUnit)(a.currency.units[0], new bignumber_js_1.BigNumber(minimalBaseAmount), {
                disableRounding: true,
                useGrouping: false,
                showCode: true,
            }),
        });
    }
    else if (minimalBaseAmount && a.balance.minus(totalSpent).lt(minimalBaseAmount)) {
        errors.amount = new errors_1.NotEnoughSpendableBalance("", {
            minimumAmount: (0, currencies_1.formatCurrencyUnit)(a.currency.units[0], new bignumber_js_1.BigNumber(minimalBaseAmount), {
                disableRounding: true,
                useGrouping: false,
                showCode: true,
            }),
        });
    }
    else if (minimalBaseAmount &&
        (t.recipient.includes("new") || notCreatedAddresses.includes(t.recipient)) &&
        amount.lt(minimalBaseAmount)) {
        // mimic XRP base minimal for new addresses
        errors.amount = new errors_1.NotEnoughBalanceBecauseDestinationNotCreated("", {
            minimalAmount: `XRP Minimum reserve`,
        });
    }
    if (!t.recipient) {
        errors.recipient = new errors_1.RecipientRequired("");
    }
    else if ((0, mockHelpers_1.isInvalidRecipient)(t.recipient)) {
        errors.recipient = new errors_1.InvalidAddress("");
    }
    else if (a.freshAddress === t.recipient) {
        errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
    }
    if (!errors.amount && amount.eq(0)) {
        errors.amount = new errors_1.AmountRequired();
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
};
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    // TODO it needs to set the fee if not in t as well
    if (!t.networkInfo) {
        return Object.assign(Object.assign({}, t), { networkInfo: {
                family: "ripple",
                serverFee: new bignumber_js_1.BigNumber(10),
                baseReserve: new bignumber_js_1.BigNumber(20),
            } });
    }
    return t;
});
const accountBridge = {
    createTransaction,
    updateTransaction: jsHelpers_1.defaultUpdateTransaction,
    getTransactionStatus,
    estimateMaxSpendable,
    prepareTransaction,
    sync: mockHelpers_1.sync,
    receive,
    signOperation: mockHelpers_1.signOperation,
    broadcast: mockHelpers_1.broadcast,
};
const currencyBridge = {
    preload: () => Promise.resolve({}),
    hydrate: () => { },
    scanAccounts: mockHelpers_1.scanAccounts,
};
exports.default = {
    currencyBridge,
    accountBridge,
};
//# sourceMappingURL=mock.js.map